<div class="main-container">
	<mat-toolbar color="accent" class="toolbar-details" mat-scroll-shrink>
		<span class="toolbar-details-title">Inventory</span>
	</mat-toolbar>
	<div class="router-container">
		<app-inventory-grid [pageName]="PAGE_NAME.APP_INVENTORY_LIST"></app-inventory-grid>
	</div>
</div>
